import React, { Component } from 'react'
import { extendObservable } from 'mobx'
import { observer, inject } from 'mobx-react'
import PropTypes from 'prop-types'
import { Route, withRouter } from 'react-router-dom'
import Logs from '@components/Logs'

import Spinner from '@components/spinner'
import Scroll from '@components/Scroll'
import Badge from '@components/Details/Badge'
import Star from '@components/Icon/Star'
import Tabs from '@components/Tabs'
import LocalTime from '@components/Details/LocalTime'

import ClientContactStore from './client-contact.store'

import DetailsTab from './DetailsTab'
import ProjectsTab from './ProjectsTab'
import CopyButton from '../../components/CopyButton'

class ClientContactPage extends Component {
  static propTypes = {
    match: PropTypes.shape({
      params: PropTypes.shape({
        id: PropTypes.string
      }).isRequired,
      url: PropTypes.string
    }).isRequired,
    singleContact: PropTypes.object,
    projectCount: PropTypes.number,
    localTime: PropTypes.string,
    history: PropTypes.object,
    staticData: PropTypes.object,
    growlStore: PropTypes.object,
    clientContactSearchStore: PropTypes.object
  }

  constructor (props) {
    super(props)

    const { staticData, growlStore, clientContactSearchStore } = props
    extendObservable(this, {
      clientContactStore: new ClientContactStore(
        staticData,
        growlStore,
        clientContactSearchStore
      )
    })

    const clientId = Number(props.match.params.id)

    this.clientContactStore.getContact(clientId)
    this.clientContactStore.getProjectCount(clientId)
  }

  renderStatus (contact) {
    const activeInactive = contact.status ? 'active' : 'inactive'
    return (
      <div className={`status-label status-label-${activeInactive} m-l-lg`}>
        {activeInactive.toUpperCase()}
      </div>
    )
  }

  render () {
    const { clientContactStore, props } = this
    const { history, match } = props

    const { contact, projectCount, loading } = clientContactStore

    const tabs = [
      {
        tab: 'details'
      },
      {
        tab: 'projects'
      },
      {
        tab: 'logs'
      }
    ]

    const urlMatch = match.url.match(/search/)
    const isLinkToFullPage = urlMatch && urlMatch.length > 0

    if (loading) {
      return <Spinner />
    }

    return (
      <Scroll>
        <div className='expert-wrapper'>
          <div className='details-header'>
            <div className='info info--noLeft'>
              <div>
                <div className='name-status-wrapper client-contact'>
                  <h1
                    className={isLinkToFullPage ? 'title-link' : ''}
                    onClick={() =>
                      isLinkToFullPage &&
                      history.push(`/client-contact/${contact.id}`)
                    }
                  >
                    {contact.title} {contact.fullName}{' '}
                  </h1>
                  {this.renderStatus(contact)}{' '}
                  <CopyButton value={contact.fullName} />
                </div>
                <span className='code-label'>
                  {contact.client.account.companyName}, {contact.country}
                </span>
              </div>
            </div>
            <LocalTime
              timezoneId={contact.address && contact.address.timezoneId}
              label='local time'
              format='HH:mm'
            />
            <div className='floating'>
              <div>
                <h1>
                  <Star />
                  {contact.averageFeedback ? contact.averageFeedback : 'N/A'}
                </h1>
                <span className='feedback-text'>Feedback</span>
              </div>
            </div>
            <Badge label='Projects' value={projectCount} />
          </div>
          <div className='expert-tabs'>
            <Tabs tabs={tabs} />
          </div>
          <div className='views-wrapper'>
            <Route
              exact
              path={match.url}
              render={props => (
                <DetailsTab
                  {...props}
                  clientContactStore={clientContactStore}
                />
              )}
            />
            <Route
              exact
              path={match.url + '/projects'}
              render={props => (
                <ProjectsTab
                  {...props}
                  clientContactStore={clientContactStore}
                />
              )}
            />
            <Route
              path={match.url + '/logs'}
              render={props => (
                <Logs {...props} type='client' itemId={match.params.id} />
              )}
            />
          </div>
        </div>
      </Scroll>
    )
  }
}

export default withRouter(
  inject('staticData', 'growlStore')(observer(ClientContactPage))
)
